const annShipServiceTypes = {
  fedex_ground: 'FEDEX GROUND',
  fedex_home_delivery: 'FEDEX HOME DELIVERY',
  fedex_2_day: 'FEDEX 2 DAY',
  fedex_standard_overnight: 'FEDEX STANDARD OVERNIGHT',
  fedex_priority_overnight: 'FEDEX PRIORITY OVERNIGHT',
  ups_next_day_air: 'UPS NEXT DAY AIR',
  ups_next_day_air_saver: 'UPS NEXT DAY AIR SAVER',
  ups_second_day_air: 'UPS SECOND DAY AIR',
  ups_ground: 'UPS GROUND',
  usps_first: 'USPS FIRST',
  usps_parcel_select: 'USPS PARCEL SELECT',
  usps_priority: 'USPS PRIORITY',
  usps_priority_express: 'USPS PRIORITY EXPRESS'
};

export default annShipServiceTypes;
